
export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: '住宅リフォーム',
      description: 'キッチン、バスルーム、内装など住宅全般のリフォームを承ります。岡山市・倉敷市での豊富な施工実績があります。',
      image: 'https://public.readdy.ai/ai/img_res/aa372d4fdbb1daff1b38d2dc8aef6aac.jpg'
    },
    {
      icon: 'ri-tools-line',
      title: '修繕工事',
      description: '雨漏り修理、外壁補修、屋根工事など、建物の修繕工事を迅速かつ丁寧に対応いたします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20construction%20worker%20doing%20repair%20work%20on%20building%20exterior%2C%20safety%20equipment%2C%20quality%20tools%2C%20careful%20craftsmanship%2C%20maintenance%20work%2C%20skilled%20technician&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-store-2-line',
      title: '店舗工事',
      description: '飲食店、美容室、オフィスなど、店舗の新装・改装工事を手がけています。お客様のご要望に合わせた設計・施工を行います。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20restaurant%20interior%20renovation%20with%20clean%20design%2C%20wooden%20elements%2C%20contemporary%20lighting%2C%20professional%20kitchen%20equipment%2C%20comfortable%20seating%20area%2C%20stylish%20commercial%20space&width=400&height=300&seq=service3&orientation=landscape'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>サービス内容</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            岡山県内でのリフォーム・修繕工事・店舗工事なら、25年の実績を持つおかやまリフォーム株式会社にお任せください
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-40 sm:h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 sm:p-6">
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className={`${service.icon} text-xl sm:text-2xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
